import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {Content as $b579958ab95f14cb$export$7c6e2c02157bb7d2} from "../view/Content.mjs";
import {DatePickerField as $ac97b87622c58dce$export$34dc4cfa15ead1} from "./DatePickerField.mjs";
import "./styles.css";
import $6sl3d$styles_cssmjs from "./styles_css.mjs";
import {Dialog as $8054558191a4f1c9$export$3ddf2d174ce01153} from "../dialog/Dialog.mjs";
import {DialogTrigger as $41e0ad2a982a34c5$export$2e1e1122cf0cba88} from "../dialog/DialogTrigger.mjs";
import {Field as $adcd096854d27620$export$a455218a85c89869} from "../label/Field.mjs";
import {FieldButton as $9b445aa2bd8cce4c$export$47dc48f595b075da} from "../button/FieldButton.mjs";
import {Flex as $ec3baf921918e057$export$f51f4c4ede09e011} from "../layout/Flex.mjs";
import {Input as $51cb122633c52627$export$f5b8910cec6cf069} from "./Input.mjs";
import $6sl3d$intlStringsmjs from "./intlStrings.mjs";
import {RangeCalendar as $a03fb7d0c639da6e$export$a4f5c8b89d277a8d} from "../calendar/RangeCalendar.mjs";
import "../inputgroup_vars.css";
import $6sl3d$inputgroup_vars_cssmjs from "../inputgroup_vars_css.mjs";
import {TimeField as $81f52c4b0082835e$export$5eaee2322dd727eb} from "./TimeField.mjs";
import {useFocusManagerRef as $d24c665d02225161$export$71a23a36270e4bf0, useFormatHelpText as $d24c665d02225161$export$322f4580ccd8dde6, useFormattedDateWidth as $d24c665d02225161$export$31e22e3c931fc056, useVisibleMonths as $d24c665d02225161$export$12ce2869ce471b1f} from "./utils.mjs";
import {useFormProps as $c29c48d4ef19ffc4$export$a6b5be5c6b451665} from "../form/Form.mjs";
import {useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {useDateRangePicker as $6sl3d$useDateRangePicker} from "react-aria/useDateRangePicker";
import $6sl3d$spectrumiconsworkflowCalendar from "@spectrum-icons/workflow/Calendar";
import {mergeProps as $6sl3d$mergeProps} from "react-aria/mergeProps";
import $6sl3d$react, {useRef as $6sl3d$useRef} from "react";
import {useDateRangePickerState as $6sl3d$useDateRangePickerState} from "react-stately/useDateRangePickerState";
import {useFocusRing as $6sl3d$useFocusRing} from "react-aria/useFocusRing";
import {useHover as $6sl3d$useHover} from "react-aria/useHover";
import {useLocale as $6sl3d$useLocale} from "react-aria/I18nProvider";
import {useLocalizedStringFormatter as $6sl3d$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

























const $2c014dcb8f84bd90$export$17334619f3ac2224 = /*#__PURE__*/ (0, $6sl3d$react).forwardRef(function DateRangePicker(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    props = (0, $c29c48d4ef19ffc4$export$a6b5be5c6b451665)(props);
    let { isQuiet: isQuiet, isDisabled: isDisabled, autoFocus: autoFocus, placeholderValue: placeholderValue, maxVisibleMonths: maxVisibleMonths = 1 } = props;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $6sl3d$useHover)({
        isDisabled: isDisabled
    });
    let targetRef = (0, $6sl3d$useRef)(null);
    let state = (0, $6sl3d$useDateRangePickerState)({
        ...props,
        shouldCloseOnSelect: ()=>!state.hasTime
    });
    let { labelProps: labelProps, groupProps: groupProps, buttonProps: buttonProps, dialogProps: dialogProps, startFieldProps: startFieldProps, endFieldProps: endFieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, calendarProps: calendarProps, isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = (0, $6sl3d$useDateRangePicker)(props, state, targetRef);
    let { isOpen: isOpen, setOpen: setOpen } = state;
    let { direction: direction } = (0, $6sl3d$useLocale)();
    let domRef = (0, $d24c665d02225161$export$71a23a36270e4bf0)(ref);
    let stringFormatter = (0, $6sl3d$useLocalizedStringFormatter)((0, ($parcel$interopDefault($6sl3d$intlStringsmjs))), '@react-spectrum/datepicker');
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $6sl3d$useFocusRing)({
        within: true,
        isTextInput: true,
        autoFocus: autoFocus
    });
    let { isFocused: isFocusedButton, focusProps: focusPropsButton } = (0, $6sl3d$useFocusRing)({
        within: false,
        isTextInput: false,
        autoFocus: autoFocus
    });
    let className = (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$inputgroup_vars_cssmjs))), 'spectrum-InputGroup', {
        'spectrum-InputGroup--quiet': isQuiet,
        'spectrum-InputGroup--invalid': isInvalid && !isDisabled,
        'is-disabled': isDisabled,
        'is-hovered': isHovered,
        'is-focused': isFocused,
        'focus-ring': isFocusVisible && !isFocusedButton
    });
    let fieldClassName = (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$inputgroup_vars_cssmjs))), 'spectrum-InputGroup-input', {
        'is-disabled': isDisabled,
        'is-invalid': isInvalid && !isDisabled
    });
    // Note: this description is intentionally not passed to useDatePicker.
    // The format help text is unnecessary for screen reader users because each segment already has a label.
    let description = (0, $d24c665d02225161$export$322f4580ccd8dde6)(props);
    if (description && !props.description) descriptionProps.id = undefined;
    let placeholder = placeholderValue;
    let timePlaceholder = placeholder && 'hour' in placeholder ? placeholder : null;
    let timeMinValue = props.minValue && 'hour' in props.minValue ? props.minValue : null;
    let timeMaxValue = props.maxValue && 'hour' in props.maxValue ? props.maxValue : null;
    let timeGranularity = state.granularity === 'hour' || state.granularity === 'minute' || state.granularity === 'second' ? state.granularity : null;
    let showTimeField = !!timeGranularity;
    let visibleMonths = (0, $d24c665d02225161$export$12ce2869ce471b1f)(maxVisibleMonths);
    let validationState = state.validationState || (isInvalid ? 'invalid' : null);
    // Multiplying by two for the two dates, adding one character for the dash, and then the padding around the dash
    let approximateWidth = `calc(${(0, $d24c665d02225161$export$31e22e3c931fc056)(state) * 2 + 1}ch + 2 * var(--spectrum-global-dimension-size-100))`;
    return /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $adcd096854d27620$export$a455218a85c89869), {
        ...props,
        ref: domRef,
        elementType: "span",
        description: description,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        validationState: validationState,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        wrapperClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$styles_cssmjs))), 'react-spectrum-Datepicker-fieldWrapper')
    }, /*#__PURE__*/ (0, $6sl3d$react).createElement("div", {
        ...(0, $6sl3d$mergeProps)(groupProps, hoverProps, focusProps),
        className: className,
        ref: targetRef
    }, /*#__PURE__*/ (0, $6sl3d$react).createElement("div", {
        style: {
            overflow: 'hidden',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $51cb122633c52627$export$f5b8910cec6cf069), {
        isDisabled: isDisabled,
        isQuiet: isQuiet,
        validationState: validationState,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$inputgroup_vars_cssmjs))), 'spectrum-InputGroup-field'),
        inputClassName: fieldClassName,
        disableFocusRing: true,
        minWidth: approximateWidth
    }, /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $ac97b87622c58dce$export$34dc4cfa15ead1), {
        ...startFieldProps,
        "data-testid": "start-date",
        isQuiet: props.isQuiet,
        inputClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$styles_cssmjs))), 'react-spectrum-Datepicker-startField')
    }), /*#__PURE__*/ (0, $6sl3d$react).createElement($2c014dcb8f84bd90$var$DateRangeDash, null), /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $ac97b87622c58dce$export$34dc4cfa15ead1), {
        ...endFieldProps,
        "data-testid": "end-date",
        isQuiet: props.isQuiet,
        inputClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$inputgroup_vars_cssmjs))), 'spectrum-Datepicker-endField', (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$styles_cssmjs))), 'react-spectrum-Datepicker-endField'))
    }))), /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $41e0ad2a982a34c5$export$2e1e1122cf0cba88), {
        type: "popover",
        mobileType: "tray",
        placement: direction === 'rtl' ? 'bottom right' : 'bottom left',
        targetRef: targetRef,
        hideArrow: true,
        isOpen: isOpen,
        onOpenChange: setOpen,
        shouldFlip: props.shouldFlip
    }, /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $9b445aa2bd8cce4c$export$47dc48f595b075da), {
        ...(0, $6sl3d$mergeProps)(buttonProps, focusPropsButton),
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$inputgroup_vars_cssmjs))), 'spectrum-FieldButton'),
        isQuiet: isQuiet,
        validationState: validationState
    }, /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $6sl3d$spectrumiconsworkflowCalendar), null)), /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $8054558191a4f1c9$export$3ddf2d174ce01153), {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$styles_cssmjs))), 'react-spectrum-Datepicker-dialog'),
        ...dialogProps
    }, /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $b579958ab95f14cb$export$7c6e2c02157bb7d2), null, /*#__PURE__*/ (0, $6sl3d$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$styles_cssmjs))), 'react-spectrum-Datepicker-dialogContent')
    }, /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $a03fb7d0c639da6e$export$a4f5c8b89d277a8d), {
        ...calendarProps,
        visibleMonths: visibleMonths,
        createCalendar: props.createCalendar,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$styles_cssmjs))), 'react-spectrum-Datepicker-calendar', {
            'is-invalid': validationState === 'invalid'
        })
    }), showTimeField && /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $ec3baf921918e057$export$f51f4c4ede09e011), {
        gap: "size-100",
        marginTop: "size-100",
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$styles_cssmjs))), 'react-spectrum-Datepicker-timeFields')
    }, /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $81f52c4b0082835e$export$5eaee2322dd727eb), {
        label: stringFormatter.format('startTime'),
        value: state.timeRange?.start || null,
        onChange: (v)=>state.setTime('start', v),
        placeholderValue: timePlaceholder,
        granularity: timeGranularity,
        minValue: timeMinValue,
        maxValue: timeMaxValue,
        hourCycle: props.hourCycle,
        hideTimeZone: props.hideTimeZone,
        flex: true
    }), /*#__PURE__*/ (0, $6sl3d$react).createElement((0, $81f52c4b0082835e$export$5eaee2322dd727eb), {
        label: stringFormatter.format('endTime'),
        value: state.timeRange?.end || null,
        onChange: (v)=>state.setTime('end', v),
        placeholderValue: timePlaceholder,
        granularity: timeGranularity,
        minValue: timeMinValue,
        maxValue: timeMaxValue,
        hourCycle: props.hourCycle,
        hideTimeZone: props.hideTimeZone,
        flex: true
    }))))))));
});
function $2c014dcb8f84bd90$var$DateRangeDash() {
    return /*#__PURE__*/ (0, $6sl3d$react).createElement("span", {
        "aria-hidden": "true",
        "data-testid": "date-range-dash",
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6sl3d$styles_cssmjs))), 'react-spectrum-Datepicker-rangeDash')
    });
}


export {$2c014dcb8f84bd90$export$17334619f3ac2224 as DateRangePicker};
//# sourceMappingURL=DateRangePicker.mjs.map
